import { useQuery } from '@tanstack/react-query';
import { platformPlansService } from 'app/javascript/services/platformPlans';

export function usePlatformPlans() {
  return useQuery({
    queryKey: ['platform-plans'],
    queryFn: () => platformPlansService.list(),
    staleTime: 15 * 60 * 1000,
  });
}
